import React, { useState } from 'react';
import { Radio } from 'antd';

const RadioItem = ({onRadioChange, value}) => {
  const onChange = (e) => {
    onRadioChange(e.target.value)
  };
  return (
    <>
    <label htmlFor="radio-items" style={{marginBottom: "20px"}} > </label>
    <Radio.Group onChange={onChange}  id="radio-items" value={value}>
      <Radio value={1} style={{color:"#fff"}}>True</Radio>
      <Radio value={0} style={{color:"#fff"}}>False</Radio>
      
      
    </Radio.Group>
    </>
  );
};
export default RadioItem;